/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet } from '../fn/submissions-secretariat-v-2/get-statistics-for-submissions-cycles-api-v-2-secretariat-submissions-org-submissions-cycles-statistics-get';
import { GetStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet$Params } from '../fn/submissions-secretariat-v-2/get-statistics-for-submissions-cycles-api-v-2-secretariat-submissions-org-submissions-cycles-statistics-get';
import { getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet } from '../fn/submissions-secretariat-v-2/get-submissions-summary-by-submissions-cycle-api-v-2-secretariat-submissions-org-submissions-cycle-id-submissions-summary-get';
import { GetSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params } from '../fn/submissions-secretariat-v-2/get-submissions-summary-by-submissions-cycle-api-v-2-secretariat-submissions-org-submissions-cycle-id-submissions-summary-get';
import { PageSubmissionsSummarySecretariat } from '../models/page-submissions-summary-secretariat';
import { SubmissionsStatisticsSecretariat } from '../models/submissions-statistics-secretariat';

@Injectable({ providedIn: 'root' })
export class SubmissionsSecretariatV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet()` */
  static readonly GetStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGetPath = '/api/v2/secretariat/submissions/{org}/submissions-cycles/statistics';

  /**
   * Get Statistics For Submissions Cycles.
   *
   * Retrieve submissions cycle statistics for a secretariat.
   *
   * This endpoint aggregates statistical data for each submission cycle associated with the secretariat.
   * It first verifies that the requesting user is a member of the organization and that the organization
   * is designated as a secretariat. Then, it retrieves all submission cycles owned by the secretariat
   * using a short view projection. For each submission cycle, it aggregates submission counts via the
   * submissions module, combining the cycle data with its corresponding summary.
   *
   * Args:
   *     tenant (str): The identifier for the secretariat, used as the owner_org_id.
   *     org (Any): The organization details, used to validate the user's membership and secretariat status.
   *
   * Returns:
   *     list[schemas.SubmissionsStatisticsSecretariat]: A list of dictionaries where each dictionary contains:
   *         - 'submissions_cycle_data': The data for a specific submission cycle.
   *         - 'submissions_summary': Aggregated statistics for that submission cycle.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *     HTTPException: If the organization is not a secretariat.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet$Response(params: GetStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsStatisticsSecretariat>>> {
    return getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Statistics For Submissions Cycles.
   *
   * Retrieve submissions cycle statistics for a secretariat.
   *
   * This endpoint aggregates statistical data for each submission cycle associated with the secretariat.
   * It first verifies that the requesting user is a member of the organization and that the organization
   * is designated as a secretariat. Then, it retrieves all submission cycles owned by the secretariat
   * using a short view projection. For each submission cycle, it aggregates submission counts via the
   * submissions module, combining the cycle data with its corresponding summary.
   *
   * Args:
   *     tenant (str): The identifier for the secretariat, used as the owner_org_id.
   *     org (Any): The organization details, used to validate the user's membership and secretariat status.
   *
   * Returns:
   *     list[schemas.SubmissionsStatisticsSecretariat]: A list of dictionaries where each dictionary contains:
   *         - 'submissions_cycle_data': The data for a specific submission cycle.
   *         - 'submissions_summary': Aggregated statistics for that submission cycle.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *     HTTPException: If the organization is not a secretariat.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet(params: GetStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet$Params, context?: HttpContext): Observable<Array<SubmissionsStatisticsSecretariat>> {
    return this.getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsStatisticsSecretariat>>): Array<SubmissionsStatisticsSecretariat> => r.body)
    );
  }

  /** Path part for operation `getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet()` */
  static readonly GetSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGetPath = '/api/v2/secretariat/submissions/{org}/submissions-cycle/{id}/submissions/summary';

  /**
   * Get Submissions Summary By Submissions Cycle.
   *
   * Retrieve a paginated summary of submissions for a specific submissions cycle.
   *
   * This endpoint fetches a summary of submission details for a given submissions cycle identified by its ID.
   * It verifies that the requesting user is a member of the organization and that the organization is a secretariat.
   * The endpoint supports filtering submissions by status, sorting by status or modification date, and filtering by the
   * supplier's company name. For each submission, key details such as submission ID, company name, organization ID,
   * category, contact email, status, modified date, and any uploaded attachments are included.
   *
   * Args:
   *     org (Any): The organization details, used to validate user permissions.
   *     id (PydanticObjectId): The unique identifier of the submissions cycle.
   *     status (list[schemas.SubmissionsStatusFilterEnum] | None, optional): Filter submissions by status.
   *     companyName (str | None, optional): Filter submissions by the supplier's company name.
   *     sortStatus (Literal["asc", "desc"] | None, optional): Sort order for the submission status.
   *     sortModifiedOn (Literal["asc", "desc"] | None, optional): Sort order for the submission modified date.
   *
   * Returns:
   *     Page[schemas.SubmissionsSummarySecretariat]: A paginated list of submission summaries,
   *     where each summary includes key details about a submission.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *     HTTPException: If the organization is not a secretariat.
   *     HTTPException: If the submissions cycle with the given ID is not found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Response(params: GetSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSubmissionsSummarySecretariat>> {
    return getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Submissions Summary By Submissions Cycle.
   *
   * Retrieve a paginated summary of submissions for a specific submissions cycle.
   *
   * This endpoint fetches a summary of submission details for a given submissions cycle identified by its ID.
   * It verifies that the requesting user is a member of the organization and that the organization is a secretariat.
   * The endpoint supports filtering submissions by status, sorting by status or modification date, and filtering by the
   * supplier's company name. For each submission, key details such as submission ID, company name, organization ID,
   * category, contact email, status, modified date, and any uploaded attachments are included.
   *
   * Args:
   *     org (Any): The organization details, used to validate user permissions.
   *     id (PydanticObjectId): The unique identifier of the submissions cycle.
   *     status (list[schemas.SubmissionsStatusFilterEnum] | None, optional): Filter submissions by status.
   *     companyName (str | None, optional): Filter submissions by the supplier's company name.
   *     sortStatus (Literal["asc", "desc"] | None, optional): Sort order for the submission status.
   *     sortModifiedOn (Literal["asc", "desc"] | None, optional): Sort order for the submission modified date.
   *
   * Returns:
   *     Page[schemas.SubmissionsSummarySecretariat]: A paginated list of submission summaries,
   *     where each summary includes key details about a submission.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *     HTTPException: If the organization is not a secretariat.
   *     HTTPException: If the submissions cycle with the given ID is not found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet(params: GetSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params, context?: HttpContext): Observable<PageSubmissionsSummarySecretariat> {
    return this.getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSubmissionsSummarySecretariat>): PageSubmissionsSummarySecretariat => r.body)
    );
  }

}
